import { render } from "./ContainerAlerts.vue?vue&type=template&id=0c53959b&scoped=true"
import script from "./ContainerAlerts.vue?vue&type=script&lang=js"
export * from "./ContainerAlerts.vue?vue&type=script&lang=js"

import "./ContainerAlerts.vue?vue&type=style&index=0&id=0c53959b&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c53959b"]])

export default __exports__